<template>
  <div class="index">
    <template v-if='id==1'>
      <div class="common_mbx">
        您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > BISAZZA质保说明
      </div>
      <div class="common_wrap">
        <img src="../../static/images/customer_s.jpg" class="top_banner">
        <div class="about_lists">
          <div class="about_item">
            <p class="about_title">
              <span class="num">售</span>
              <span>售后保障</span>
            </p>
            <div class="about_text">上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。</div>
          </div>
          </div>
        </div>
    </template>
    <template v-if='id==2'>
      <div class="common_mbx">
        您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > 卫浴质保说明
      </div>
      <div class="common_wrap">
        <img src="../../static/images/customer_s.jpg" class="top_banner">
        <div class="about_lists">
          <div class="about_item">
            <p class="about_title">
              <span class="num">售</span>
              <span>售后保障</span>
            </p>
            <div class="about_text">上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。</div>
          </div>
          </div>
        </div>
    </template>
    <template v-if='id==3'>
      <div class="common_mbx">
        您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > 户外SPA质保说明
      </div>
      <div class="common_wrap">
        <img src="../../static/images/customer_s.jpg" class="top_banner">
        <div class="about_lists">
          <div class="about_item">
            <p class="about_title">
              <span class="num">售</span>
              <span>售后保障</span>
            </p>
            <div class="about_text">上海帝景卫浴设备有限公司， 创立于2005年， 是专注于欧美原装进口产品的卫浴服务商， 致力于为中国别墅豪宅、五星级酒店及高级会所客户提供全球品质的纯进口卫浴产品及一站式系统服务。</div>
          </div>
          </div>
        </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      id:''
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){
    this.id=this.$route.params.id
  }
}
</script>

<style scoped>

 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .top_banner{
  margin-bottom: 72px;
 }
 .about_title{
  min-width: 98px;
  height: 42px;
  line-height: 42px;
  border-radius: 4px;
  background-color: #f8f7f7;
  color: #000000;
  font-size: 18px;
  margin-bottom: 30px;
  padding-right: 10px;
  display: inline-block;
 }
 .about_item{
  margin-bottom: 46px;
 }
 .num{
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  background-color: #3478f7;
  display: inline-block;
  margin-left: 7px;
 }
 .about_text{
  font-size: 14px;
  color: #000000;
  line-height: 200%;
 }
 .core_link{
  margin-bottom: 40px;
 }
 .core_link a{
  color: #3478f7;
 }
</style>


// WEBPACK FOOTER //
// src/components/customer_s.vue